import React from 'react';
import PropTypes from 'prop-types';

import { useRouter } from 'next/router';
import { CompanyProfileTabsWrapper }
from '@fuww/library/src/CompanyProfile';
import { NavTabs } from '@fuww/library/src/Tabs';
import { useIntl } from 'react-intl';
import productsQuery
from '../../lib/queries/products/companyProfileProductsQuery.graphql';
import Tab from '../Tab';
import withQuery from '../../lib/withQuery';
import messages from '../../lib/messages.mjs';
import { useSiteContext } from '../SiteContext';

const CompanyTabs = ({ data, profile }) => {
  const intl = useIntl();
  const { query: { slug }, route: currentRoute } = useRouter();
  const { products, hiddenProductsExist } = data;
  const { brands } = profile;

  return (
    <CompanyProfileTabsWrapper>
      {
      brands.length > 0
      && (hiddenProductsExist || products.length > 0)
      && (
        <NavTabs
          value={currentRoute}
          NavTab={Tab}
          tabs={[
            {
              route: 'company-profile',
              params: { slug },
              value: '/company-profile',
              label: intl.formatMessage(messages.about),
            },
            {
              route: 'company-profile-products',
              params: { slug },
              value: '/company-profile-products',
              label: intl.formatMessage(messages.products),
            },
          ]}
        />
      )
    }
    </CompanyProfileTabsWrapper>
  );
};

CompanyTabs.propTypes = {
  profile: PropTypes.shape({
    brands: PropTypes.arrayOf(PropTypes.shape({})),
    page: PropTypes.shape({
      title: PropTypes.string,
    }),
  }).isRequired,
  data: PropTypes.shape({
    products: PropTypes.arrayOf(PropTypes.shape({})),
    hiddenProductsExist: PropTypes.bool,
  }).isRequired,
};

const CompanyTabsWithQuery = withQuery(CompanyTabs);

const CompanyTabsWrapper = ({
  profile,
}) => {
  const { locale } = useSiteContext();

  return (
    <CompanyTabsWithQuery
      profile={profile}
      query={productsQuery}
      variables={{
        marketId: 1,
        brandIds: profile.brands.map(({ id }) => id),
        mainCategories: [],
        locales: [locale],
        limit: 1,
      }}
      errorMessage="Error loading company tab"
    />
  );
};

CompanyTabsWrapper.propTypes = {
  profile: PropTypes.shape({
    brands: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
};

const SchoolTabs = ({ profile }) => {
  const intl = useIntl();
  const { query: { slug }, route: currentRoute } = useRouter();
  const { coursesConnection: { edges } } = profile;

  return (
    <CompanyProfileTabsWrapper>
      {edges.length > 0 && (
      <NavTabs
        value={currentRoute}
        NavTab={Tab}
        tabs={[
          {
            route: 'company-profile',
            params: { slug },
            value: '/company-profile',
            label: intl.formatMessage(messages.about),
          },
          {
            route: 'school-profile-courses',
            params: { slug },
            value: '/school-profile-courses',
            label: 'courses',
          },
        ]}
      />
      )}
    </CompanyProfileTabsWrapper>
  );
};

SchoolTabs.propTypes = {
  profile: PropTypes.shape({
    coursesConnection: PropTypes.shape({
      edges: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  }).isRequired,
};

export { SchoolTabs, CompanyTabsWrapper };
